import { isPlainObject as estoolkitIsPlainObject } from "es-toolkit/compat";

import type { UnknownObject } from "@eroad/types";

/**
 * Type guard for checking if a value is a plain object (created by {} or new Object()).
 *
 * @param value - The value to check.
 * @returns {boolean} - Returns true if the value is a plain object, false otherwise.
 *
 * @privateRemarks
 * When used, we lose type information of the value - even if it was properly typed in the first place.
 * So please try to avoid using this function if possible.
 *
 * For example, if we have a type `type MyType = { key: string } | string` and we use `isPlainObject(value)`, the type of `value` will be `UnknownObject`.
 * But what we can do instead, is `if ("key" in value) {` which will narrow the type and remove the string from the union.
 *
 * The use case for this function would be a real unknown variable.
 */
const isPlainObject = (value: unknown): value is UnknownObject => {
  return estoolkitIsPlainObject(value);
};

export { isPlainObject };
